import CompanySalesReport from "../components/CompanySalesReport";

export default function CompanySalesReportPage() {
  return <CompanySalesReport />;
}
